import { Box, Typography, Stack, Divider, } from '@mui/material';
import groupBy from 'lodash.groupby';
import React from 'react';
import { dataConstants } from '../../../../../../constants';
import { getRandomStr, roundNum } from '../../../../../../helpers';
import { isFloat } from '../../../../../../utils';
import { parseTabData } from '../../../../../../utils/helpers';

const { STOCK_SECTION_CODES } = dataConstants;

const getDerivedValue = (val, formula, realtime_stock_data) => {

  let exp = formula.replace(/#value/g, val);
  exp = realtime_stock_data && realtime_stock_data.length > 0 ? exp.replace(/#price/g, realtime_stock_data[0].price) : exp;
  let retVal = val;

  try {
    retVal = eval(exp);
    return retVal;
  } catch (err) {
    console.error(err);
    return val;
  }
}

const CumulativeReturns = ({ tabData, info, latest_metrics }) => {
  const { ticker, realtime_stock_data } = info || {}

  // const latest_metrics = tabData && tabData.length > 0 ? tabData.find(d => d.section_code === "latest_metrics") : null;

  //returns percent
  let retItem = tabData && tabData.length > 0 ? tabData.find(d => d.section_code === 'price_action') : null;
  retItem = retItem ? parseTabData(retItem) : null
  const retData = latest_metrics && latest_metrics.tabData && latest_metrics.tabData.length > 0 ? groupBy(latest_metrics.tabData, d => d.code) : null;
  let retCnt = 0;

  return (
    <>
      {/* <Box
        className="Item-Head"
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          mb: 0.5,
          px: 0.5,
        }}
      >
        <Typography component="h4" className="option-title" sx={{ mr: 'auto', fontSize: '.875rem !important' }} >
          {retItem?.section_name || `Price Action`}
        </Typography>
      </Box> */}
      {retItem && retData &&
        <Stack
          key={getRandomStr(3)}
          // direction={{ xs: 'column', sm: 'column', md: 'row' }}
          direction={'row'} useFlexGap
          alignItems="center" justifyContent="space-between"
          divider={<Divider orientation="vertical" flexItem sx={{ borderColor: { md: "#eae9ee", sm: "#fff", xs: '#fff' } }} />}
          className="return-card s-card mt-3 bg-transparent shadow-none Item-Body"
          sx={{ mx: '8px !important', flexWrap: 'wrap' }}
        >
          {retData && retItem.settings && (retItem.settings).order && (retItem.settings).order.map(c => {
            const d = retData[c.replace(/XXXXX/g, info?.ticker)];
            const col = (retItem.settings).cols.find(it => it.code === c);
            retCnt = d && d.length > 0 ? retCnt + 1 : retCnt;
            const val = d && d.length > 0 ? (col?.formula ? getDerivedValue(d[0].value, col?.formula, realtime_stock_data) : d[0].value) : null;
            return (val && col && retCnt ?
              <Stack key={getRandomStr(3)} spacing={{ xs: 1.2, sm: 1.2, md: 4 }} direction="row" alignItems="center" justifyContent="space-between" className="s-assets-title" sx={{ mb: 0 }}  >
                <Box component='div' className="s-assets-title">
                  <Typography variant="subtitle2" className="td-cap" sx={{ mb: 0, fontSize: '.875rem !important', fontWeight: '600 !important' }}> {col?.desc}</Typography>
                </Box>
                <Box component='div' className="s-assets-title">
                  <Typography variant="subtitle2" className="td-cap"
                    sx={{ mb: 0, fontSize: '.875rem !important', fontWeight: '600 !important', color: col?.isPct && val < 0 ? '#DB3353' : 'inherit' }}
                  >
                    {`${isFloat(val) ? roundNum(val, col?.isPct ? 1 : 2) : val}${col?.isPct ? '%' : ''}`}
                  </Typography>
                </Box>
              </Stack>
              : null);
          })}
        </Stack>}
    </>
  )
}

export default React.memo(CumulativeReturns)


// {
//   retItem && retData &&
//   <Box className="return-card s-card mt-3 bg-transparent shadow-none">
//     {retData &&
//       <Grid container spacing={2}>
//         {retItem.settings && (retItem.settings).order && (retItem.settings).order.map(c => {
//           const d = retData[c.replace(/XXXXX/g, info?.ticker)];
//           const col = (retItem.settings).cols.find(it => it.code === c);
//           retCnt = d && d.length > 0 ? retCnt + 1 : retCnt;
//           const val = d && d.length > 0 ? (col?.formula ? getDerivedValue(d[0].value, col?.formula, realtime_stock_data) : d[0].value) : null;
//           return (val && col && retCnt ?
//             <Grid size={{ md: 6, sm: 12 }} key={getRandomStr(3)} className="col-md-12 draw-item pt-3">
//               <Box className="draw-head">
//                 <Typography variant="h5" className="draw-val">{`${isFloat(val) ? roundNum(val, col?.isPct ? 1 : 2) : val}${col?.isPct ? '%' : ''}`}</Typography>
//               </Box>
//               <Divider />
//               <Typography variant="caption" className="draw-desc" sx={{ my: 1 }}>
//                 {col?.desc}
//               </Typography>
//             </Grid>
//             : null);
//         })}
//       </Grid>}
//   </Box>
// }
